<template>
  <div v-if="visible" class="bbl-upload-modal-overlay" @click="handleOverlayClick">
    <div class="bbl-upload-modal" @click.stop>
      <div class="bbl-modal-header">
        <h3>{{ isEditing ? 'Edit Link' : 'Insert Link' }}</h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>
      
      <div class="bbl-modal-body">
        <div class="bbl-form-group">
          <label for="link-text">Link Text</label>
          <input
            id="link-text"
            v-model="linkText"
            type="text"
            class="form-input"
            placeholder="Enter link text"
          >
        </div>
        
        <div class="bbl-form-group">
          <label for="link-url">URL</label>
          <input
            id="link-url"
            v-model="linkUrl"
            type="url"
            class="form-input"
            placeholder="https://example.com"
          >
        </div>
        
        <div class="bbl-form-group">
          <label class="checkbox-label">
            <input
              v-model="openInNewTab"
              type="checkbox"
              class="checkbox-input"
            >
            Open in new tab
          </label>
        </div>
      </div>
      
      <div class="bbl-modal-footer">
        <button class="cancel-btn" @click="close">Cancel</button>
        <button v-if="isEditing" class="remove-btn" @click="removeLink">Remove Link</button>
        <button class="insert-btn" @click="insertLink">
          {{ isEditing ? 'Update Link' : 'Insert Link' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialText: {
      type: String,
      default: ''
    },
    initialUrl: {
      type: String,
      default: ''
    },
    initialTarget: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'insert', 'remove'],
  data() {
    return {
      linkText: this.initialText,
      linkUrl: this.initialUrl,
      openInNewTab: this.initialTarget === '_blank'
    }
  },
  computed: {
    isEditing() {
      return !!this.initialUrl
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.linkText = this.initialText
        this.linkUrl = this.initialUrl
        this.openInNewTab = this.initialTarget === '_blank'
      }
    }
  },
  methods: {
    close() {
      this.linkText = ''
      this.linkUrl = ''
      this.openInNewTab = false
      this.$emit('close')
    },
    
    handleOverlayClick(e) {
      if (e.target === e.currentTarget) {
        this.close()
      }
    },
    
    insertLink() {
      if (!this.linkUrl.trim()) {
        alert('Please enter a URL')
        return
      }
      
      const linkData = {
        href: this.linkUrl.trim(),
        target: this.openInNewTab ? '_blank' : null
      }
      
      if (this.linkText.trim()) {
        linkData.text = this.linkText.trim()
      }
      
      this.$emit('insert', linkData)
      this.close()
    },
    
    removeLink() {
      this.$emit('remove')
      this.close()
    }
  }
}
</script>

<style scoped>
.bbl-upload-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.bbl-upload-modal {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.bbl-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.bbl-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
}

.bbl-form-group {
  margin-bottom: 16px;
}

.bbl-form-group label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-input {
  margin: 0;
}

.bbl-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
}

.cancel-btn {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #374151;
  cursor: pointer;
}

.remove-btn {
  padding: 8px 16px;
  border: 1px solid #ef4444;
  border-radius: 6px;
  background: white;
  color: #ef4444;
  cursor: pointer;
}

.insert-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: #3b82f6;
  color: white;
  cursor: pointer;
}
</style>